import { memo, useEffect, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import GlobalIcon from "../GlobalIcon/GlobalIcon";
import { BrandLoader } from "../Brand";
import { formatRefreshTimestamp } from "../../utils/bookRefreshTime";
import {
  CLOCK_FORMAT_CHANGED,
  getClockFormat,
  is12HourClockFormat,
} from "../../utils/clockFormatPreference";
import styles from "./BookRefreshBar.module.css";

function BookRefreshBar({ lastRefreshAt, onReload, isLoading, disabled }) {
  const [clockFormat, setClockFormat] = useState(() => getClockFormat());

  useEffect(() => {
    const onFormatChange = (event) => {
      setClockFormat(event?.detail?.format ?? getClockFormat());
    };
    window.addEventListener(CLOCK_FORMAT_CHANGED, onFormatChange);
    return () => window.removeEventListener(CLOCK_FORMAT_CHANGED, onFormatChange);
  }, []);

  const stamp =
    lastRefreshAt != null
      ? formatRefreshTimestamp(lastRefreshAt, is12HourClockFormat(clockFormat))
      : "";

  return (
    <div className={styles.wrap}>
      <div className={styles.status}>
        <span className={styles.loaderSlot} aria-hidden={!isLoading}>
          {isLoading ? <BrandLoader variant="icon" caption="" /> : null}
        </span>
        {stamp ? (
          <span className={styles.meta}>
            Last refreshed: <span className={styles.metaTime}>{stamp}</span>
          </span>
        ) : (
          <span className={styles.meta}>{isLoading ? "Loading…" : "—"}</span>
        )}
      </div>
      <Tooltip title="Refresh">
        <span className={styles.iconBtnWrap}>
          <IconButton
            type="button"
            size="small"
            className={styles.reloadIconBtn}
            onClick={onReload}
            disabled={disabled || isLoading}
            aria-label="Refresh"
          >
            <GlobalIcon iconName="RefreshIcon" width={14} height={14} aria-hidden />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
}

export default memo(BookRefreshBar);
